module.exports = __webpack_public_path__ + "static/DonaAlt-Regular-6830a99b6ad7f1bf2d642aac66a21cc8.woff";